export default {
  LOAD_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST_START: 'LoadStudentCompetencySubmittedSurveyListStart',
  LOAD_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST_END: 'LoadStudentCompetencySubmittedSurveyListEnd',
  CLEAR_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST: 'ClearStudentCompetencySubmittedSurveyList',
  SORT_STUDENT_COMPETENCY_SUBMITTED_SURVEY_LIST: 'SortStudentCompetencySubmittedSurveyList'
};
